import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-642449741__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Ordner / digital", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-642449741__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M176 133.81V46.87c0-3.79-3.08-6.87-6.87-6.87H22.87C19.08 40 16 43.08 16 46.87v86.94c0 3.79 3.08 6.87 6.87 6.87h146.26c3.79 0 6.87-3.08 6.87-6.87m-43.4-16.75c0 2.21-1.79 4-4 4H63.4c-2.21 0-4-1.79-4-4V61.85c0-2.21 1.79-4 4-4h18.79c1.15 0 2.25.5 3 1.36L96.9 72.53h31.7c2.21 0 4 1.79 4 4z",
      style: {"fill":"none"}
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M169.13 148.68c8.2 0 14.87-6.67 14.87-14.87V46.87c0-8.2-6.67-14.87-14.87-14.87H22.87C14.67 32 8 38.67 8 46.87v86.94c0 8.2 6.67 14.87 14.87 14.87H92v12.49H65.43v8h61.13v-8H99.99v-12.49h69.13Zm-146.26-8c-3.79 0-6.87-3.08-6.87-6.87V46.87c0-3.79 3.08-6.87 6.87-6.87h146.26c3.79 0 6.87 3.08 6.87 6.87v86.94c0 3.79-3.08 6.87-6.87 6.87z",
      class: "i-642449741__cls-2"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M128.6 72.53H96.9L85.19 59.21a4 4 0 0 0-3-1.36H63.4c-2.21 0-4 1.79-4 4v55.21c0 2.21 1.79 4 4 4h65.21c2.21 0 4-1.79 4-4V76.53c0-2.21-1.79-4-4-4Zm-4 40.53H67.39V65.85h12.98l5.87 6.68H73.98v8h50.61v32.53Z",
      class: "i-642449741__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "computerDocument"}) } }